import React, { useContext, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import AppContext from '../Context/AppContext';
import SearchBox from '../mainScreenComponents/SearchBox';

const Header = () => {
    const navigate = useNavigate();
    const ctx = useContext(AppContext);
    const logout = () => {
        ctx.logout();
        navigate('/');
    };

    return (
        <>
            <div className='navbar shadow-md mb-2.5'>
                <div className='navbar-start'>
                    <Link to='/' className='navbar-item font-medium'>
                        <span>ReWatch</span>
                    </Link>
                    <div className='navbar-end'>
                        <SearchBox />
                    </div>
                </div>
            </div>
        </>
    );
};

export default Header;
